module.exports = __webpack_public_path__ + "static/img/6-1.50e21d8f.png";